import underwritingIcon from '../../../assets/icons/underwriting.svg';
import tourIcon from '../../../assets/icons/tour.svg';
import invoiceIcon from '../../../assets/icons/invoice.svg';
import analyticsIcon from '../../../assets/icons/analytics.svg';

export enum SignupVariant {
  DEFAULT = 'DEFAULT',
  MARKET_SCAN = 'MARKET_SCAN',
}

interface SignupVariantContent {
  /** Trans key; <1> wraps the greyed-out part of the title. */
  titleKey: string;
  features: { descriptionKey: string; icon: string }[];
  ctaHeadingKey: string;
  ctaButtonKey: string;
}

export const SIGNUP_VARIANT_CONTENT: Record<SignupVariant, SignupVariantContent> = {
  [SignupVariant.DEFAULT]: {
    titleKey: 'signup.start_your_application',
    features: [
      { descriptionKey: 'signup.features.share_data', icon: underwritingIcon },
      { descriptionKey: 'signup.features.benchmark_roas', icon: tourIcon },
      { descriptionKey: 'signup.features.eligibility_check', icon: invoiceIcon },
      { descriptionKey: 'signup.features.roas_model', icon: analyticsIcon },
    ],
    ctaHeadingKey: 'signup.sign_up_access',
    ctaButtonKey: 'signup.sign_up',
  },
  [SignupVariant.MARKET_SCAN]: {
    titleKey: 'signup.market_scan.title',
    features: [
      { descriptionKey: 'signup.market_scan.features.free_reports', icon: analyticsIcon },
      { descriptionKey: 'signup.market_scan.features.connect_data', icon: underwritingIcon },
      { descriptionKey: 'signup.market_scan.features.funding_eligibility', icon: invoiceIcon },
      { descriptionKey: 'signup.market_scan.features.benchmark_roas', icon: tourIcon },
    ],
    ctaHeadingKey: 'signup.market_scan.sign_up_access',
    ctaButtonKey: 'signup.market_scan.sign_up',
  },
};
